export default {
  methods: {
    blockSidebarSelection (parentEmit = true) {
      if (parentEmit) {
        this.$parent.$emit('selection-blocked')
      } else {
        this.$emit('selection-blocked')
      }
    },
    unblockSidebarSelection (parentEmit = true) {
      if (parentEmit) {
        this.$parent.$emit('selection-unblocked')
      } else {
        this.$emit('selection-unblocked')
      }
    }
  }
}
